// src/hooks/useDayPhase.ts
/**
 * 判斷當前一天所處的心理階段
 *
 * - morning：06:00–10:59（早晨啟動感）
 * - active：11:00–18:59（白天動能感）
 * - evening：19:00–23:59（收尾感，對齊 DayCloseSection 時間窗口）
 *
 * 使用 useCurrentTime 確保每分鐘自動更新，時間窗口切換時畫面自動切換
 */

import { useMemo } from 'react';
import { useCurrentTime } from './useCurrentTime';

export type DayPhase = 'morning' | 'active' | 'evening';

export function useDayPhase(): DayPhase {
  const currentTime = useCurrentTime(60000);

  return useMemo(() => {
    const hour = currentTime.getHours();
    if (hour >= 6 && hour < 11) return 'morning';
    if (hour >= 19) return 'evening';
    return 'active';
  }, [currentTime]);
}
